import { AppointmentDocumentsReports } from 'Features/Appointments';
import { AllAppointmentDocumentsReports } from 'Features/Appointments/AllAppointmentDocumentsReports';
import {
  PhysicianInfo,
  ReferralRawDocumentList,
  ReferralNotes,
  ViewReferral,
  ReferralInternalNotes,
  EmployerInfo,
} from 'Features/Referrals';
import { Permission } from 'Models/Templates/Permission/Permission';
import { AdminSubRouteConfig, SubRoutes } from 'Navigation/NavigationTypes';

export enum ReferralSubRoute {
  View = '/View',
  Appointments = '/Appointments',
  Documents = '/Documents',
  PhysicianInfo = '/PhysicianInfo',
  Reports = '/Reports',
  Notes = '/Notes',
  InternalNotes = '/InternalNotes',
  AllDouments = '/AllDocuments',
  EmployerInfo = '/EmployerInfo',
}

export enum ReferralSubRouteV3 {
  Reports = '/Reports',
  MedicalRecords = '/Appointments',
  CaseDetail = '/View',
}

export const ReferralSubRoutes: SubRoutes = {
  [ReferralSubRoute.View]: new AdminSubRouteConfig(
    ReferralSubRoute.View,
    'View',
    ViewReferral,
    true,
    [Permission.ViewReferral]
  ),
  [ReferralSubRoute.Reports]: new AdminSubRouteConfig(
    ReferralSubRoute.Reports,
    'Documents & Reports',
    AppointmentDocumentsReports,
    false,
    [Permission.ViewAppointmentDocument, Permission.ViewAppointmentReport]
  ),
  [ReferralSubRouteV3.MedicalRecords]: new AdminSubRouteConfig(
    ReferralSubRouteV3.MedicalRecords,
    'Medical Records',
    ReferralRawDocumentList,
    false,
    [Permission.ViewMedicalRecords]
  ),
  [ReferralSubRoute.Documents]: new AdminSubRouteConfig(
    ReferralSubRoute.Documents,
    'Raw Documents',
    ReferralRawDocumentList,
    false,
    [Permission.ViewReferralRawDocument]
  ),
  [ReferralSubRoute.PhysicianInfo]: new AdminSubRouteConfig(
    ReferralSubRoute.PhysicianInfo,
    'Physician Info',
    PhysicianInfo,
    false,
    [Permission.ViewPhysician]
  ),
  [ReferralSubRoute.EmployerInfo]: new AdminSubRouteConfig(
    ReferralSubRoute.EmployerInfo,
    'Employer Info',
    EmployerInfo,
    false,
    [Permission.ViewReferral]
  ),
  [ReferralSubRoute.Notes]: new AdminSubRouteConfig(
    ReferralSubRoute.Notes,
    'Call Notes',
    ReferralNotes,
    false,
    [Permission.ViewNote]
  ),
  [ReferralSubRoute.InternalNotes]: new AdminSubRouteConfig(
    ReferralSubRoute.InternalNotes,
    'Internal Notes',
    ReferralInternalNotes,
    false,
    [Permission.ViewInternalNote]
  ),
  [ReferralSubRoute.AllDouments]: new AdminSubRouteConfig(
    ReferralSubRoute.AllDouments,
    'All Documents & Reports',
    AllAppointmentDocumentsReports,
    false,
    [Permission.ViewAllDocuments]
  ),
};

export const ReferralSubRoutesV3: SubRoutes = {
  [ReferralSubRouteV3.Reports]: new AdminSubRouteConfig(
    ReferralSubRouteV3.Reports,
    'Reports',
    AppointmentDocumentsReports,
    false,
    [Permission.ViewAppointmentDocument, Permission.ViewAppointmentReport]
  ),
  [ReferralSubRouteV3.MedicalRecords]: new AdminSubRouteConfig(
    ReferralSubRouteV3.MedicalRecords,
    'Medical Records',
    ReferralRawDocumentList,
    false,
    [Permission.ViewMedicalRecords]
  ),
  [ReferralSubRouteV3.CaseDetail]: new AdminSubRouteConfig(
    ReferralSubRouteV3.CaseDetail,
    'Case Detail',
    ViewReferral,
    true,
    [Permission.ViewReferral]
  ),
  [ReferralSubRoute.Notes]: new AdminSubRouteConfig(
    ReferralSubRoute.Notes,
    'Call Notes',
    ReferralNotes,
    false,
    [Permission.ViewNote]
  ),
};
